import React from "react";
import Loading from "../components/Loading";
// import Services from "../components/Services";
// import Banner from "../components/Banner";
const Home = () => {
  return (
    <>
    
      <Loading />
    </>
  );
};

export default Home;
